import { styled } from "@mui/material";
import { Active } from "./IndustrySetUp";

interface ComponentProps {
   IndustryId: number;
   IndustryName:string;
   IndustrySector:string;
   IsActive:boolean;
}

const ViewRoleContent : React.FC<ComponentProps> = ({IndustryName, IndustryId, IndustrySector, IsActive }) => {
    
    return (
        <StyledContainer>
            <StyledWrapper>
                <StyledText>Status</StyledText>
                <Active disabled={IsActive}>{IsActive?'Active':'Disabled'}</Active>
            </StyledWrapper>
            <StyledWrapper>
                <StyledText>Industry Name</StyledText>
                <StyledText> {IndustryName}</StyledText>
            </StyledWrapper>
            {/* <StyledWrapper>
              <StyledText>Industry Sector</StyledText>
              <StyledText> {IndustrySector}</StyledText>
            </StyledWrapper> */}
      
        </StyledContainer>
    )
}

export default ViewRoleContent;

const StyledContainer = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    padding-block-start: 3rem;
    padding-block-end: 5rem;
    padding-inline: 2rem;
`

const StyledWrapper = styled('div')`
    display: flex;
    justify-content: space-between;
`

const StyledText = styled('span')`
    font-size: 24px;
    font-weight: 400;
    color: #4E5A62;
`
const StyledText2 = styled('span')`
    font-size: 24px;
    font-weight: 500;
    color: #020D08;
    width:100%
`

/* const Active = styled('span')`
    font-size: 16px;
    font-weight: 500;
    background-color: #E0FAEE;
    border-radius: 0.4rem;
    padding-inline: 2rem;
    padding-block: 0.5rem;
    color: #11643C;
` */

const StyledDate = styled(StyledText)`
    color: #020D08;
    font-weight: 500;
`